export default "__VITE_ASSET__DHyJlQNI__"